module.exports = __webpack_public_path__ + "img/a11y-support_en.eecc927.jpg";